if (!customElements.get('hv-sale-countdown')) {
  class HVSaleCountdown extends HTMLElement {
    static remaining(now) {
      const date = new Date(now);
      let end = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 14, 59);
      if (now >= end) end += 86400000;
      return Math.max(0, Math.floor((end - now) / 1000));
    }

    connectedCallback() {
      clearInterval(this.timer);
      this.anchor = performance.now();
      this.serverNow = Number(this.dataset.serverNow) * 1000 || Date.now();
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      if (!this.hours || !this.minutes || !this.seconds) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = HVSaleCountdown.remaining(this.serverNow + performance.now() - this.anchor);
      this.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      this.minutes.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
      this.seconds.textContent = String(remaining % 60).padStart(2, '0');
    }
  }
  customElements.define('hv-sale-countdown', HVSaleCountdown);
}
